import { t_dataName } from "src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service";

export type t_CalibrationDataPoint = {
    generalName: string;
    dataName: t_dataName;
    value?: number;
};

export type t_CalibrationDataset = {
    dataPoints: t_CalibrationDataPoint[];
};

export var initCalibrationCabineDataset: t_CalibrationDataset = {
    dataPoints: [
        {
            generalName: 'CabineStartCalibration',
            dataName: {
                name: 'CabineStartCalibration',
            }
        },
        {
            generalName: 'CabineCalibrationRunning',
            dataName: {
                name: 'CabineCalibrationRunning',
            }
        },
        {
            generalName: 'CabineMoveCabineToLowerEndposition',
            dataName: {
                name: 'CabineMoveCabineToLowerEndposition',
            }
        },
        {
            generalName: 'CabineInLowerEndposition',
            dataName: {
                name: 'CabineInLowerEndposition',
            }
        },
        {
            generalName: 'CabineMoveCabineToUpperEndposition',
            dataName: {
                name: 'CabineMoveCabineToUpperEndposition',
            }
        },
        {
            generalName: 'CabineInUpperEndposition',
            dataName: {
                name: 'CabineInUpperEndposition',
            }
        },
        {
            generalName: 'CabineCalibrationSuccessful',
            dataName: {
                name: 'CabineCalibrationSuccessful',
            }
        },
    ]
};

export var initCalibrationPedalDataset: t_CalibrationDataset = {
    dataPoints: [
        {
            generalName: 'PedalControlStartTeaching',
            dataName: {
                name: 'PedalControlStartTeaching',
            }
        },
        {
            generalName: 'PedalControlPressPedalDown',
            dataName: {
                name: 'PedalControlPressPedalDown',
            }
        },
        {
            generalName: 'PedalControlTeachingSuccessful',
            dataName: {
                name: 'PedalControlTeachingSuccessful',
            }
        },
    ]
};

export var initCalibrationJoystickHorizontalDataset: t_CalibrationDataset = {
    dataPoints: [
        {
            generalName: 'JoystickRightStartClibrFingertipLeftRight',
            dataName: {
                name: 'JoystickRightStartClibrFingertipLeftRight',
            }
        },
        {
            generalName: 'JoystickRightCalibrRunningFingertipLeftRight',
            dataName: {
                name: 'JoystickRightCalibrRunningFingertipLeftRight',
            }
        },
        {
            generalName: 'JoystickRightCalibrMoveFingertipLeft',
            dataName: {
                name: 'JoystickRightCalibrMoveFingertipLeft',
            }
        },
        {
            generalName: 'JoystickRightCalibrSuccessfulFingertipLeftRight',
            dataName: {
                name: 'JoystickRightCalibrSuccessfulFingertipLeftRight',
            }
        },
    ]
};

export var initCalibrationJoystickVerticalDataset: t_CalibrationDataset = {
    dataPoints: [
        {
            generalName: 'JoystickRightStartClibrFingertipUpDown',
            dataName: {
                name: 'JoystickRightStartClibrFingertipUpDown',
            }
        },
        {
            generalName: 'JoystickRightCalibrRunningFingertipUpDown',
            dataName: {
                name: 'JoystickRightCalibrRunningFingertipUpDown',
            }
        },
        {
            generalName: 'JoystickRightCalibrMoveFingertipUp',
            dataName: {
                name: 'JoystickRightCalibrMoveFingertipUp',
            }
        },
        {
            generalName: 'JoystickRightCalibrSuccessfulFingertipUpDown',
            dataName: {
                name: 'JoystickRightCalibrSuccessfulFingertipUpDown',
            }
        },
    ]
};